var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$root.user.isAdmin
      ? _c("div", { staticClass: "row", attrs: { id: "account-wrap" } }, [
          _c("div", {
            staticClass: "avatar",
            class: "avatar--" + _vm.subscription.icon
          }),
          _vm._v(" "),
          _c("div", { staticClass: "account-info" }, [
            _c("div", { staticClass: "table" }, [
              _c("div", { staticClass: "cell" }, [
                _c("div", { staticClass: "account-info__title" }, [
                  _vm._v(_vm._s(_vm.user.fullName))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "account-info__subtitle" }, [
                  _vm._v("Klantnummer " + _vm._s(_vm.user.poc))
                ])
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.user.loginType === "web" && _vm.$root.app.platform == "desktop"
      ? _c("div", [
          _vm.$root.app.platform == "ios" && _vm.$root.user.isAdmin
            ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row row-button" }, [
            _c(
              "div",
              {
                staticClass: "col col-100",
                on: {
                  click: function($event) {
                    return _vm.logout()
                  }
                }
              },
              [
                _c("button", { staticClass: "button signout" }, [
                  _vm._v("Uitloggen")
                ])
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.hasSms
      ? _c("div", { staticClass: "row head" }, [
          _c("div", { staticClass: "row-wrap" }, [
            _vm.$root.user.active
              ? _c("div", { staticClass: "rows" }, [
                  _c(
                    "div",
                    { staticClass: "row row-single setting" },
                    [
                      _c("router-link", { attrs: { to: "/messages" } }, [
                        _vm.$root.app.platform == "ios"
                          ? _c("div", { staticClass: "col col-100" }, [
                              _c("span", { staticClass: "row__title" }, [
                                _vm._v("Berichten")
                              ])
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row-wrap" }, [
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "row head" }, [
            _c("div", { staticClass: "col col-100" }, [
              _vm._v("Accountgegevens")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.user.active
        ? _c("div", { staticClass: "rows" }, [
            _c(
              "div",
              { staticClass: "row row-first setting outgoing-number" },
              [
                _vm.$root.app.platform == "android"
                  ? _c("div", { staticClass: "col col-100" }, [
                      _c("span", { staticClass: "row__title" }, [
                        _vm._v("Uitgaand nummer")
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "row__subtitle" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.numberIndex,
                                expression: "numberIndex"
                              }
                            ],
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.numberIndex = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function($event) {
                                  return _vm.changedValue($event)
                                }
                              ]
                            }
                          },
                          _vm._l(_vm.phoneNumbers, function(phoneNumber) {
                            return _c(
                              "option",
                              {
                                key: phoneNumber.id,
                                domProps: { value: phoneNumber.number_id }
                              },
                              [
                                _vm._v(
                                  "\n                                      " +
                                    _vm._s(
                                      phoneNumber.phoneNumber +
                                        " (" +
                                        phoneNumber.name +
                                        ")"
                                    ) +
                                    "\n                                  "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$root.app.platform == "ios"
                  ? _c("div", { staticClass: "col col-50" }, [
                      _c("span", { staticClass: "row__title" }, [
                        _vm._v("Uitgaand nummer")
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$root.app.platform == "ios"
                  ? _c("div", { staticClass: "col col-50" }, [
                      _c("span", { staticClass: "row__subtitle" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.numberIndex,
                                expression: "numberIndex"
                              }
                            ],
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.numberIndex = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function($event) {
                                  return _vm.changedValue($event)
                                }
                              ]
                            }
                          },
                          _vm._l(_vm.phoneNumbers, function(phoneNumber) {
                            return _c(
                              "option",
                              {
                                key: phoneNumber.id,
                                domProps: { value: phoneNumber.number_id }
                              },
                              [
                                _vm._v(
                                  "\n                                      " +
                                    _vm._s(
                                      phoneNumber.phoneNumber +
                                        " (" +
                                        phoneNumber.name +
                                        ")"
                                    ) +
                                    "\n                                  "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.$root.user.isAdmin
              ? _c(
                  "div",
                  { staticClass: "row setting has-subitem" },
                  [
                    _c("router-link", { attrs: { to: "/email-edit" } }, [
                      _vm.$root.app.platform == "android"
                        ? _c("div", { staticClass: "col col-100" }, [
                            _c("span", { staticClass: "row__title" }, [
                              _vm._v("E-mailadres")
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "row__subtitle" }, [
                              _vm._v(
                                _vm._s(_vm._f("truncate")(_vm.user.email, 20))
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$root.app.platform == "ios"
                        ? _c("div", { staticClass: "col col-50" }, [
                            _c("span", { staticClass: "row__title" }, [
                              _vm._v("E-mailadres")
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$root.app.platform == "ios"
                        ? _c("div", { staticClass: "col col-50" }, [
                            _c("span", { staticClass: "row__subtitle" }, [
                              _vm._v(
                                _vm._s(_vm._f("truncate")(_vm.user.email, 20))
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.subscription.accessType == "3"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "row row-last setting has-subitem" },
                    [
                      _c("router-link", { attrs: { to: "/credit" } }, [
                        _vm.$root.app.platform == "android"
                          ? _c("div", { staticClass: "col col-100" }, [
                              _c("span", { staticClass: "row__title" }, [
                                _vm._v("Tegoed")
                              ]),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$root.app.platform == "ios"
                          ? _c("div", { staticClass: "col col-50" }, [
                              _c("span", { staticClass: "row__title" }, [
                                _vm._v("Tegoed")
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$root.app.platform == "ios"
                          ? _c("div", { staticClass: "col col-50" }, [
                              _c("span", { staticClass: "row__title" }, [
                                _vm._v(" ")
                              ])
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.subscription.accessType == "1"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "row setting has-subitem" },
                    [
                      _c("router-link", { attrs: { to: "/numbers" } }, [
                        _vm.$root.app.platform == "android"
                          ? _c("div", { staticClass: "col col-100" }, [
                              _c("span", { staticClass: "row__title" }, [
                                _vm._v("Nummer instellingen")
                              ]),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$root.app.platform == "ios"
                          ? _c("div", { staticClass: "col col-100" }, [
                              _c("span", { staticClass: "row__title" }, [
                                _vm._v("Nummer instellingen")
                              ])
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.$root.user.isAdmin
                    ? _c(
                        "div",
                        {
                          staticClass: "row setting has-subitem",
                          class: {
                            "setting--nb":
                              _vm.subscription.status != "active" &&
                              _vm.$root.app.platform == "ios"
                          }
                        },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/subscriptions" } },
                            [
                              _vm.$root.app.platform == "android"
                                ? _c("div", { staticClass: "col col-100" }, [
                                    _c("span", { staticClass: "row__title" }, [
                                      _vm._v("Abonnement")
                                    ]),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "row__subtitle" },
                                      [_vm._v(_vm._s(_vm.subscription.name))]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$root.app.platform == "ios"
                                ? _c("div", { staticClass: "col col-50" }, [
                                    _c("span", { staticClass: "row__title" }, [
                                      _vm._v("Abonnement")
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$root.app.platform == "ios"
                                ? _c("div", { staticClass: "col col-50" }, [
                                    _c(
                                      "span",
                                      { staticClass: "row__subtitle" },
                                      [_vm._v(_vm._s(_vm.subscription.name))]
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.subscription.status != "active"
              ? _c(
                  "div",
                  { staticClass: "row row-last explanation explanation--bb" },
                  [
                    _vm.subscription.status == "cancelled"
                      ? _c("div", [
                          _vm._v("\n\n          Je abonnement is opgezegd op "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.subscription.cancelTime))
                          ]),
                          _vm._v(" en verloopt op\n          "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.subscription.expireTime))
                          ]),
                          _vm._v(".\n        ")
                        ])
                      : _c("div", [
                          _vm._v("\n\n          Je abonnement is verlopen op "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.subscription.cancelTime))
                          ]),
                          _vm._v(
                            ". Wil je een nieuw abonnement?\n          Neem dan contact op met onze helpdesk.\n        "
                          )
                        ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.subscription.accessType == "1"
              ? _c("div", [
                  _vm.$root.user.isAdmin
                    ? _c(
                        "div",
                        { staticClass: "row row-last setting has-subitem" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "account/bundles-overview",
                                  params: { poc: _vm.$root.user.poc }
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "col col-100" }, [
                                _c("span", { staticClass: "row__title" }, [
                                  _vm._v("Bundels")
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ])
        : _c("div", [_vm._m(0)])
    ]),
    _vm._v(" "),
    _vm.$root.app.platform == "ios" && _vm.subscription.status == "active"
      ? _c("div", { staticClass: "row spacer" }, [_vm._v(" \n  ")])
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.user.isAdmin
      ? _c(
          "div",
          { staticClass: "row row-first setting has-subitem" },
          [
            _c("router-link", { attrs: { to: "/account" } }, [
              _c("div", { staticClass: "col col-100" }, [
                _c("span", { staticClass: "row__title" }, [
                  _vm._v("Persoonlijke gegevens")
                ])
              ])
            ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.user.isAdmin
      ? _c(
          "div",
          { staticClass: "row setting has-subitem" },
          [
            _c("router-link", { attrs: { to: "/usage" } }, [
              _c("div", { staticClass: "col col-100" }, [
                _c("span", { staticClass: "row__title" }, [_vm._v("Verbruik")]),
                _c("br")
              ])
            ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.user.isAdmin
      ? _c(
          "div",
          { staticClass: "row setting has-subitem" },
          [
            _c("router-link", { attrs: { to: "/blacklist" } }, [
              _c("div", { staticClass: "col col-100" }, [
                _c("span", { staticClass: "row__title" }, [
                  _vm._v("Blokkades")
                ]),
                _c("br")
              ])
            ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.user.isAdmin
      ? _c(
          "div",
          { staticClass: "row setting has-subitem" },
          [
            _c("router-link", { attrs: { to: "/invoices" } }, [
              _c("div", { staticClass: "col col-100" }, [
                _c("span", { staticClass: "row__title" }, [_vm._v("Facturen")])
              ])
            ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.user.isAdmin
      ? _c(
          "div",
          { staticClass: "row setting has-subitem" },
          [
            _c("router-link", { attrs: { to: "/settings" } }, [
              _c("div", { staticClass: "col col-100" }, [
                _c("span", { staticClass: "row__title" }, [
                  _vm._v("Configuratie")
                ])
              ])
            ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.user.isAdmin
      ? _c(
          "div",
          { staticClass: "row row-last setting has-subitem" },
          [
            _c("router-link", { attrs: { to: "/feedback" } }, [
              _c("div", { staticClass: "col col-100" }, [
                _c("span", { staticClass: "row__title" }, [
                  _vm._v("Ondersteuning")
                ])
              ])
            ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    (_vm.$root.user.loginType === "web" && _vm.$root.app.platform == "ios") ||
    _vm.$root.app.platform == "android"
      ? _c("div", [
          _vm.$root.app.platform == "ios" && _vm.$root.user.isAdmin
            ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row row-button" }, [
            _c(
              "div",
              {
                staticClass: "col col-100",
                on: {
                  click: function($event) {
                    return _vm.logout()
                  }
                }
              },
              [
                _c("button", { staticClass: "button signout" }, [
                  _vm._v("Uitloggen")
                ])
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.app.platform == "ios"
      ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row setting explanation" }, [
      _c("strong", [_vm._v("Inactief account")]),
      _c("br"),
      _vm._v(
        "\n        Je account heeft geen actief abonnement. Wil je een nieuw abonnement? Neem dan contact op met onze helpdesk\n        via 'Ondersteuning'.\n      "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aae30ed8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aae30ed8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = null
// module chunks = 